import React from "react";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import { gettext } from "web/script/modules/django-i18n";
import { getURL } from "web/script/routing/getUrl";
import styles from "./ccpa-cookie-banner.css";

interface CcpaCookieBannerProps {
    onCloseButtonClick: () => void;
}

export default function CcpaCookieBanner({
    onCloseButtonClick,
}: CcpaCookieBannerProps): JSX.Element {
    return (
        <div className={styles.bannerContainer}>
            <div className={styles.contentContainer}>
                <p className={styles.description}>
                    <span>{`${gettext("ccpa_banner.description")} `}</span>
                    <span>
                        <a className={styles.readMore} href={`${getURL("helpPrivacyPolicy")}#ccpa`}>
                            {gettext("general.read_more")}
                        </a>
                    </span>
                </p>
                <CloseButton className={styles.closeButton} onClick={onCloseButtonClick} />
            </div>
        </div>
    );
}
